import { cloneDeep } from "lodash";

export const setActiveContentShowLabels = ({
  contents,
  activeContentId,
  showLabels,
}) => {
  return contents.map((content) => {
    if (content.id === activeContentId) {
      content.showLabels = showLabels;
    }

    return cloneDeep(content);
  });
};

export default setActiveContentShowLabels;
